import React, { memo, useContext } from 'react'

import { LanguageContext } from 'context/LanguageContext'
import { countryCode } from 'utils/appUtils'
import { useSelector } from 'react-redux'
import { util } from 'utils'
import { getCDNURL } from 'network/api/networkSettings'

const WebFooter = memo(props => {
    const logo = getCDNURL() + 'assets/images/7eleven_logo_white.webp'

    const { rtl, strings, formatString } = useContext(LanguageContext)
    const year = util.getFullYear()
    const month = util.getCurrentMonthName()
    const isLoading = useSelector(state => state.languageChange.get('isLoading'))

    return (
        <>
            <div className="row">
                <div className="col-12 links-and-app">
                    <nav className="links-and-app-nav-links">
                        <ul className="links-and-app-nav-links-list">
                            <li tabIndex="0" className="links-and-app-nav-links-title">
                                {isLoading ? 'GET TO KNOW US' : strings.knowus}
                            </li>
                            <li className="link-item">
                                <a
                                    href={strings.LINKS_aboutPage}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {isLoading ? 'About 7-Eleven Hawaii' : strings.about}
                                </a>
                            </li>
                            <li className="link-item">
                                <a
                                    href={strings.LINKS_storeLocations}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {isLoading ? 'All Locations' : strings.locations}
                                </a>
                            </li>
                        </ul>
                        <ul className="links-and-app-nav-links-list">
                            <li tabIndex="0" className="links-and-app-nav-links-title">
                                {isLoading ? 'HOW CAN WE HELP?' : strings.help}
                            </li>
                            <li className="link-item">
                                <a
                                    href={strings.LINKS_feedbackPage}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {isLoading ? 'Leave Feedback' : strings.feedbackText}
                                </a>
                            </li>
                            <li className="link-item">
                                <a
                                    href={strings.LINKS_aboutPage}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {isLoading ? 'Contact Us' : strings.contactText}
                                </a>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
            <div className="row">
                <div className="col-12 terms-and-social">
                    <div className="conditions-and-privacy" tabIndex="0">
                        <img
                            src={logo}
                            alt="7-Eleven logo"
                            className="conditions-and-privacy-logo"
                        />
                        <div className="conditions-and-privacy-content">
                            <nav className="conditions-and-privacy-content-links">
                                <ul>
                                    <li className="link-item">
                                        <a
                                            href={props.termsLink}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            {isLoading ? 'Terms & Conditions' : strings.termsLink}
                                        </a>
                                    </li>
                                    <li className="link-item">
                                        <a
                                            href={props.privacyLink}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            {isLoading ? ' Privacy Policy' : strings.privacyLink}
                                        </a>
                                    </li>
                                </ul>
                            </nav>
                            <span className="intended-use">
                                {props.userCountry === countryCode.CA
                                    ? strings.canadaIntended
                                    : isLoading
                                      ? 'This site is intended for residents of the U.S.'
                                      : strings.intended}
                            </span>
                            <span className="rights">
                                &copy;
                                {isLoading
                                    ? `${year} 7-Eleven Hawaii, Inc. All rights reserved. Products and services available at participating locations.`
                                    : formatString('rights', { year })}
                            </span>
                        </div>
                    </div>
                    <nav className="social-media-links">
                        <ul className={`social-media-links-list${rtl ? '__right' : ''}`}>
                            <li>
                                <a
                                    href={
                                        props.userCountry === countryCode.CA
                                            ? strings.LINKS_canadaFacebookPage
                                            : strings.LINKS_facebookPage
                                    }
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <img
                                        src={getCDNURL() + 'assets/images/facebook_logo.svg'}
                                        alt="Facebook Logo"
                                    />
                                </a>
                            </li>
                            <li>
                                <a
                                    href={
                                        props.userCountry === countryCode.CA
                                            ? strings.LINKS_canadaTwitterPage
                                            : strings.LINKS_twitterPage
                                    }
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <img
                                        src={getCDNURL() + 'assets/images/twitter_logo.svg'}
                                        alt="Twitter Logo"
                                    />
                                </a>
                            </li>
                            <li>
                                <a
                                    href={
                                        props.userCountry === countryCode.CA
                                            ? strings.LINKS_canadaInstagramPage
                                            : strings.LINKS_instagramPage
                                    }
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <img
                                        src={getCDNURL() + 'assets/images/instagram_logo.svg'}
                                        alt="Instagram Logo"
                                    />
                                </a>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
            <div className="row">
                <div className="col-12 disclaimer" tabIndex="0">
                    <p className="disclaimer-description">
                        {isLoading
                            ? `*. Average delivery time across all markets as of ${month} ${year}
                                was about 30 minutes. Your actual delivery time may be longer,
                                depending on driver availability, weather and traffic conditions.`
                            : formatString('landingPageDisclaimer', { 0: month, 1: year })}
                    </p>
                    <p className="disclaimer-description">
                        {isLoading
                            ? ' Pricing, promotions and availability may vary by location and at 7NOW Hawaii'
                            : strings.landingPageDisclaimer1}
                    </p>
                </div>
            </div>
        </>
    )
})

export default WebFooter
